import {
  Component,
  ComponentFactoryResolver,
  ViewContainerRef,
  ViewEncapsulation,
  ComponentRef,
  EventEmitter,
  Output,
  ChangeDetectorRef,
  Input
} from '@angular/core';

@Component({
    selector: 'inst-add-observation',
    templateUrl: './add-observation.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AddInstallationObservationComponent {
  @Output()
  public toggleSave: EventEmitter<any> = new EventEmitter();
  @Output()
  public toggleCancel: EventEmitter<any> = new EventEmitter();
  public isOpen: boolean = false;
  cmpRef: ComponentRef<any>;
  @Output()
  public modalClosed: EventEmitter<any> = new EventEmitter();

  public component: any;
  public observation: any;

  @Input()
  public title: string;

  public save() {
    this.dispose();
    this.toggleSave.emit(this.observation);
  }

  public cancel() {
    this.dispose();
    this.toggleCancel.emit();
  }

  constructor(
    public componentFactoryResolver: ComponentFactoryResolver,
    public viewContainer: ViewContainerRef,
    private cdf: ChangeDetectorRef
  ) {}

  open(observation: any) {
    this.observation = observation;
    this.isOpen = true;
    this.cdf.detectChanges();
  }

  dispose() {
    this.isOpen = false;
    if (this.component != undefined) {
      this.component.then((componentRef: ComponentRef<any>) => {
        componentRef.destroy();
        return componentRef;
      });
    }
  }

  close() {
    this.dispose();
  }

  updateInformAdmin() {
    this.observation.ToInformAdmin = !this.observation.ToInformAdmin;
  }

  isInform() {
    return this.observation.ToInformAdmin;
  }
}
